// "Install Re:Vault": a quiet note, at most once a week and 3 times in all, offering the browser's own install
// (Chromebook first: it puts Re:Vault on the shelf in its own window). Only once a student has
// come back on 3 different days, never on a first visit, never while Study Hall, a focus timer,
// the welcome or another dialog is in front, and never once installed. Settings > Advanced >
// "Offer to install Re:Vault" turns it off for good. The days are kept on this device only, as
// dates, and not at all in incognito or with history off. This is the gate; the note itself is
// the lazy chunk app/notes.js, loaded only on the day it can show.
import { INSTALL_KEY, NEED_DAYS, dayKey, noteDay, mayOffer } from "../shared/notes-core.js";
import { whenWelcomeClosed } from "./onboarding-gate.js";
import { noCredentialless } from "../shared/isolation.js";

const SAFARI_KEY = "revault:safari-saves";
let notesUrl = __RVM.notesJs; // a let, so esbuild leaves the import alone
const read = () => { try { return JSON.parse(localStorage.getItem(INSTALL_KEY)); } catch { return null; } };
export const standalone = () => { try { return matchMedia("(display-mode: standalone), (display-mode: window-controls-overlay), (display-mode: minimal-ui)").matches || navigator.standalone === true; } catch { return false; } };

// ctx: what notes.js needs from the app (see main.js).
export function initInstall(ctx) {
	if (ctx.inOS || standalone()) return;
	// Safari never offers an install prompt, and it clears what a site saved after 7 days without a
	// visit (a Home Screen copy is exempt): once, on a third day, a note says how to keep it.
	const safari = !("onbeforeinstallprompt" in window) && noCredentialless();
	if (!safari && !("onbeforeinstallprompt" in window)) return;
	const keeps = () => ctx.get("incognito") !== true && ctx.get("keepHistory") !== false;
	if (keeps()) { try { localStorage.setItem(INSTALL_KEY, JSON.stringify(noteDay(read(), dayKey(new Date())))); } catch { /* not kept: no note */ } }
	if (safari) {
		const once = () => { try { return !localStorage.getItem(SAFARI_KEY); } catch { return false; } };
		const may = () => keeps() && once() && ctx.get("installPrompt") !== false && ((read() || {}).days || []).length >= NEED_DAYS;
		whenWelcomeClosed(() => setTimeout(() => {
			if (may()) import(notesUrl).then((m) => m.safariNote(ctx, { may, key: SAFARI_KEY })).catch(() => {});
		}, 20000));
		return;
	}
	let deferred = null;
	// Chrome's own install button in the address bar still works; this only holds the mini-bar back.
	addEventListener("beforeinstallprompt", (e) => { e.preventDefault(); deferred = e; });
	const could = () => keeps() && mayOffer(read(), { now: Date.now(), setting: ctx.get("installPrompt"), standalone: false, busy: false, canPrompt: true });
	whenWelcomeClosed(() => setTimeout(() => {
		if (could()) import(notesUrl).then((m) => m.installNote(ctx, { read, could, prompt: () => deferred, used: () => { deferred = null; } })).catch(() => {});
	}, 20000));
}
